export const ERP = process.env.REACT_APP_ERP_API_ENDPOINT;
export const SERVICE_MANAGER_API_HUB = process.env.REACT_APP_SERVICE_MANAGER_API_HUB;